
import Vue from 'vue';
/**
- This only contains the container. 
- To modify the width, background color, position, modify class <b> .eu-tooltips-container </b> as this container has already absolute position. </li>
- For text color modify <b> .eu-tooltips-text </b> 
- Pass prop <b>arrowPointer</b> to set where the arrow points.
**/
export default Vue.extend<any, any, any, any>({
  name: 'Tooltips',
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set text in the tooltips
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * Set arrow pointer (top, left, bottom, right, ect)
     */
    arrowPointer: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    arrowClasses() {
      return {
        top: this.arrowPointer === 'top',
        topLeft: this.arrowPointer === 'topLeft',
        topRight: this.arrowPointer === 'topRight',
        bottomLeft: this.arrowPointer === 'bottomLeft',
        bottomRight: this.arrowPointer === 'bottomRight',
        left: this.arrowPointer === 'left',
        right: this.arrowPointer === 'right',
        bottom: this.arrowPointer === 'bottom'
      };
    }
  }
});
